import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import Prev from "./Prev";
import SendIv from "./SendIv";
import Loader from "../../../../loader/FetchLoader";
import { adminURL } from "../../../../../utils/urls";

const PreviewEvent = () => {
  const { eventID } = useParams();
  const navigate = useNavigate();

  const { data: eventData, isLoading } = useQuery({
    queryKey: ["event", eventID],
    queryFn: async () => {
      try {
        const response = await adminURL.get(`events/${eventID}`);
        if (response.status === 200) {
          // console.log(response?.data?.data?.event);
          return response.data.data.event;
        } else {
          navigate("/login");
          return null;
        }
      } catch (error) {
        // console.error("Error fetching event details:");
        throw error;
      }
    },
    refetchInterval: 2000, 
    refetchIntervalInBackground: true, 
  });

  return (
    <section
      style={{ backgroundColor: "rgba(12, 17, 23, 1)" }}
      className="flex flex-col items-center justify-center w-full max-w-[1020px] mx-auto"
    >
      <div className="w-full flex justify-center text-center border-b border-customBackgroundTwo">
        <header className="flex justify-center items-center rounded-md space-x-8 w-full py-6">
          <h1 className="text-xl text-white">Invitation Mail</h1>
        </header>
      </div>

      {isLoading ? (
        <Loader text="loading event..." />
      ) : (
        <>
          <h2 className="text-white text-2xl my-4">{eventData?.name}</h2>
          <p className="text-white">{eventData?.description}</p>
          <Prev data={eventData} id={eventID} />
          <SendIv eventData={eventData} />
        </>
      )}
    </section>
  );
};

export default PreviewEvent;
